module.exports = __webpack_public_path__ + "static/media/0.20b223b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/0.jpg
// module id = 95
// module chunks = 0